import ProspectorProApiService from './ProspectorProApiService';

export default class ContactService extends ProspectorProApiService {
  getActivityForAgent(identifier, data, fullResponse) {
    return this.get('/ContactREST/contact-activity-for-agent', data, identifier, fullResponse);
  }

  getStatsForAgent(identifier, data) {
    return this.get('/ContactREST/contact-stats-for-agent', data, identifier);
  }

  createContactRating(data) {
    return this.postRaw('/ContactRatingREST/rating', data);
  }

  updateContactRating(data) {
    return this.putRaw('/ContactRatingREST/rating', data);
  }

}
